import { useEffect, useState } from "react";
import { aulaGetMyCourses, teacherGetRuns } from "../api/academic";

function getFetchRunsByRole(role) {
    if (role === "teacher") return teacherGetRuns;
    return aulaGetMyCourses;
}

export default function useAcademicRuns({ role = "student" } = {}) {
    const [runs, setRuns] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        const fetchRuns = getFetchRunsByRole(role);

        setLoading(true);
        setError(null);

        fetchRuns()
            .then((data) => {
                if (cancelled) return;
                const normalizedRuns = Array.isArray(data)
                    ? data
                    : Array.isArray(data?.results)
                        ? data.results
                        : [];
                setRuns(normalizedRuns);
            })
            .catch((e) => {
                if (cancelled) return;
                setRuns([]);
                setError(e?.response?.data?.error || "No se pudieron cargar los cursos.");
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [role]);

    return {
        runs,
        loading,
        error,
    };
}
